// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3OBAw","title":"Images90_title__35qrB","images":"Images90_images__2YP6u"};